import { removeResolvers } from '@/helper/Resolver/removeResolvers';
import { transformProps } from '@/helper/Resolver/transformProps';
import { useColorScheme } from "@/hooks/useColorScheme";
import { forwardRef } from 'react';
import { StyleSheet } from "react-native";

export const withStyles = (Component, compStyle = {}) => {
    
    const WrappedComponent = forwardRef((props, ref) => {
        const colorScheme = useColorScheme();

        const {
            style = {},
            ...restComp
        } = compStyle;

        const restProps = removeResolvers(props);
        const styleProps = transformProps(props, style, colorScheme);

        const safeStyle = Array.isArray(styleProps)
            ? StyleSheet.flatten(styleProps)
            : styleProps;

        return (
            <Component
                ref={ref}
                style={safeStyle}
                {...restComp}
                {...restProps}
            />
        );
    });

    WrappedComponent.displayName = `withStyles(${Component.displayName || Component.name || "Component"})`;

    return WrappedComponent;
};

